import React from 'react';

const Receipt = (extraStyles?: React.CSSProperties) => {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={extraStyles}>
            <path d="M3 21V3H21V21L18.5455 19.3636L15.2727 21L12 19.3636L8.72727 21L5.45455 19.3636L3 21Z" fill="white"/>
            <path d="M7.09091 8.72727H16.9091M7.09091 12.8182H12H16.9091M3 21V3H21V21L18.5455 19.3636L15.2727 21L12 19.3636L8.72727 21L5.45455 19.3636L3 21Z" stroke="black"/>
        </svg>
    );
};

export default Receipt;

